import { getNavigationGroups } from '@zeiss/lib-helpers';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { getAuthorizedNavigationItems } from 'src/components/layout';
import { useGlobalEvaluations } from 'src/hooks';

/**
 * Hook to build navigation groups based on authorization and current
 * location.
 */
export const useNavigationGroups = () => {
  const { pathname } = useLocation();
  const { t } = useTranslation(['common']);
  const { can } = useGlobalEvaluations();

  const navigationGroups = useMemo(() => {
    const authorizedNavigationItems = getAuthorizedNavigationItems({
      can,
      t,
    });

    const groups = [
      authorizedNavigationItems.map(({ href, icon, title }) => ({
        href,
        icon,
        title,
      })),
    ];

    return getNavigationGroups({ groups, pathname });
  }, [can, pathname, t]);

  return navigationGroups;
};
